<div class="dialog-wrapper">
  <mat-icon
    style="
      color: hsl(42, 96%, 58%);
      font-size: 100px;
      width: 100px;
      height: 100px;
    "
  >
    {{ data.icon }}</mat-icon
  >
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <p style="text-align: center; line-height: normal">
    {{ data.paragraph }}
  </p>
  <p style="font-weight: bolder">
    {{ data.question }}
  </p>
  <mat-dialog-actions class="dialog-buttons" align="center">
    <button mat-button mat-dialog-close class="dialog-button back-button" *ngIf="!data.onlyOneBtn">
      {{ lextranslate.i18n["1deff2f1-f5ae-453b-a963-6d67417e456d"] }}
    </button>
    <button
      mat-button
      [mat-dialog-close]="true"
      cdkFocusInitial
      class="dialog-button confirm-button"
    >
      {{ data.buttonText }}
    </button>
  </mat-dialog-actions>
</div>
